import gql from "graphql-tag";

export const GET_TASK = gql`
    query Task($taskId: ID){
        task(taskId: $taskId) {
            taskId
            userId
            parentType
            parentId
            taskParentId
            shareCategoryType
            shareCategoryId
            taskName
            taskDescription
            taskType
            taskStatus
            taskPriority
            startAt
            dueAt
            completed
            completedAt
            createdAt
            updatedAt
            deleted
            deletedAt
            account {
                accountId
                accountName
            }
            contact {
                contactId
                contactSalutation
                contactFirstName
                contactMiddleName
                contactLastName
                contactSuffix
                contactNickName
            }
            project {
                projectId
                projectName
                projectDescription
                projectStatus
                projectPriority
                startAt
                endAt
            }
            team {
                teamId
                teamName
            }
            integration {
                integrationId
                integrationName
            }
        }
    }
`;

export const GET_TASKS = gql`
    query Tasks($parentType: String, $parentId: ID, $shareCategoryType: String, $shareCategoryId: ID, $searchStr: String, $limit: Int, $offset: Int, $showCompleted: Boolean, $showDeleted: Boolean, $orderList: [String]){
        tasks(parentType: $parentType, parentId: $parentId, shareCategoryType: $shareCategoryType, shareCategoryId: $shareCategoryId, searchStr: $searchStr, limit: $limit, offset: $offset, showCompleted: $showCompleted, showDeleted: $showDeleted, orderList: $orderList) {
            taskId
            userId
            parentType
            parentId
            taskParentId
            shareCategoryType
            shareCategoryId
            taskName
            taskDescription
            taskType
            taskStatus
            taskPriority
            startAt
            dueAt
            completed
            completedAt
            createdAt
            updatedAt
            deleted
            deletedAt
            account {
                accountId
                accountName
            }
            contact {
                contactId
                contactSalutation
                contactFirstName
                contactMiddleName
                contactLastName
                contactSuffix
                contactNickName
            }
            project {
                projectId
                projectName
                projectDescription
                projectStatus
                projectPriority
                startAt
                endAt
            }
            team {
                teamId
                teamName
            }
            integration {
                integrationId
                integrationName
            }
        }
    }
`;

export const CREATE_TASK = gql`
    mutation CreateTask($newTask: newTask!) {
        createTask(
            newTask: $newTask
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_TASK = gql`
    mutation UpdateTask($changedTask: changedTask!) {
        updateTask(
            changedTask: $changedTask
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_TASK = gql`
    mutation DeleteTask($deleteTaskId: ID!) {
        deleteTask(
            deleteTaskId: $deleteTaskId
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_TASKS = gql`
    mutation DeleteTasks($deleteTaskIds: [ID!]!) {
        deleteTasks(
            deleteTaskIds: $deleteTaskIds
        ) {
            returnCode
            message
        }
    }
`;
